module.exports = __webpack_public_path__ + "static/media/step9.c6fdee77.png";